import { render, staticRenderFns } from "./ProductImages.vue?vue&type=template&id=48ce73b4"
import script from "./ProductImages.vue?vue&type=script&lang=js"
export * from "./ProductImages.vue?vue&type=script&lang=js"
import style0 from "./ProductImages.vue?vue&type=style&index=0&id=48ce73b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports